import { render, staticRenderFns } from "./project-group-table.vue?vue&type=template&id=46246491"
import script from "./project-group-table.vue?vue&type=script&lang=js"
export * from "./project-group-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports